import { Injectable } from '@angular/core';
import { Location } from '../interfaces/attendance.interface';
import { ConfigurationsService } from 'src/app/shared/services/configurations.service';
import { REFRESH_INDEXED } from 'src/app/core/indexedDB/helpers/enums.enums';
import { from, map, switchMap } from 'rxjs';
import { localDB } from 'src/app/shared/helpers/localStorage';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AttendanceLocationService {
  isActiveModal: boolean = false
  constructor(
    private readonly _configService: ConfigurationsService,
  ) {
    this.differenctBSedeAndLocation()
  }

  public getLocation(): Promise<Location> {
    return new Promise((resolve, reject) => {
      const location: Location = {
        latitude: null,
        longitude: null,
        accuracy: null,
        isSuccess: true,
        sMessage: ''
      };

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            location.latitude = position.coords.latitude;
            location.longitude = position.coords.longitude;
            location.accuracy = position.coords.accuracy;
            resolve(location);
          },
          (error) => {
            location.isSuccess = false
            switch (error.code) {
              case error.PERMISSION_DENIED:
                location.sMessage = "No tienes permisos de geolocalización en este dispositivo";
                break;
              case error.POSITION_UNAVAILABLE:
                location.sMessage = "La información de ubicación no está disponible.";
                break;
              case error.TIMEOUT:
                location.sMessage = "La solicitud de ubicación ha expirado.";
                break;
              default:
                location.sMessage = "Ocurrió un error, comunicate con el área de desarrollo smart"
                break;
            }
            resolve(location);
          }
        );
      } else {
        location.isSuccess = false
        location.sMessage = "Geolocalización no es soportada por el navegador."
        resolve(location);
      }
    });
  }

  public differenceBetweenCoordinates(LocationControl: Location, Location02: Location): { difference: number, isSuccess: boolean } {
    let result = {
      difference: 0,
      isSuccess: true
    }

    // Convertir todas las coordenadas a radianes
    const lat1 = this.gradosARadianes(LocationControl.latitude!);
    const lon1 = this.gradosARadianes(LocationControl.longitude!);
    const lat2 = this.gradosARadianes(Location02.latitude!);
    const lon2 = this.gradosARadianes(Location02.longitude!); // Corrección aquí

    // Aplicar fórmula de Haversine
    const RADIO_TIERRA_EN_KILOMETROS = 6371;
    let diferenciaEntreLongitudes = lon2 - lon1;
    let diferenciaEntreLatitudes = lat2 - lat1;
    let a = Math.pow(Math.sin(diferenciaEntreLatitudes / 2.0), 2)
      + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(diferenciaEntreLongitudes / 2.0), 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // Convertir la distancia a metros
    result.difference = RADIO_TIERRA_EN_KILOMETROS * c * 1000;
    return result;
  }

  public differenctBSedeAndLocation(bUsePermision: boolean = true) {
    let result = {
      difference: 0,
      sMessage: 'No se puede obtener una ubicación precisa con el dispositivo actual',
      isSuccess: false,
      LocationControl: {},
      LocationCompare: {}
    }

    let date = moment().format('YYYY-MM-DD HH:mm:ss')
    return this._configService.getConfig(REFRESH_INDEXED.EVERY_REFRESH, ['localizacion_predeterminada', 'modalidad_asistencia', 'rango_marcas'], undefined, undefined, undefined, date, Number(localDB.getItem('idColaborador'))).pipe(
      switchMap(config => {
        return from(this.getLocation()).pipe(
          map(coor => {
            result.isSuccess = coor.isSuccess!
            if (coor.isSuccess) {
              let rango_marcas = Number(config['RANGO_MARCAS'][0].sCodigo)

              let predeterminateLocation = JSON.parse(config['LOCALIZACION_PREDETERMINADA'][0].sDescripcion)[0];

              result.LocationControl = predeterminateLocation
              result.LocationCompare = coor

              let locationValidate = this.differenceBetweenCoordinates(predeterminateLocation, coor);

              result.isSuccess = locationValidate.isSuccess
              result.difference = locationValidate.difference
              result.isSuccess = locationValidate.isSuccess
              if (config['MODALIDAD_ASISTENCIA'][0].sCodigo != '3') {
                if (locationValidate.isSuccess && locationValidate.difference >= rango_marcas) {
                  result.isSuccess = false
                  result.sMessage = 'Debes estar en la oficina para poder realizar marcaciones'
                } else if (locationValidate.isSuccess && coor.accuracy! <= 20) {
                  result.sMessage = `La precisión de tu ubicación es de ${Math.floor(coor.accuracy!)} metros`
                }
              }
            } else {
              result.sMessage = coor.sMessage!
            }
            return result
          })
        );
      })
    );

  }

  private gradosARadianes(grados: number) {
    return grados * Math.PI / 180;
  };
}